export default __webpack_public_path__ + "static/media/easy-cambodia.ec78ffe3.png";